import { Info } from 'assets/assetsV1/iconComponents/Info';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';

const TitleComponent = () => (
  <>
    <Info boxSize="32px" />
    <span style={{ marginLeft: '4px' }}>Confirmation</span>
  </>
);

export const DeleteCSVFileModal = ({ onDelete, isModalOpen, setIsModalOpen }) => (
  // const dispatch = useDispatch();

  // if (isSaveViewModalOpen && isSuccess) {
  //   // resetting is important for showing the modal for new views
  //   resetMutation();
  //   setIsModalOpen(false);
  //   dispatch(resetView());
  // }

  <ConfirmationModal
    isCentered
    isOpen={isModalOpen}
    onClose={() => setIsModalOpen(false)}
    title={<TitleComponent />}
    body="Deleting your .csv file will remove the uploaded list of employees. This will also deselect your employees selected through .csv file"
    cancelText="Cancel"
    onCancel={() => setIsModalOpen(false)}
    continueText="Delete"
    onContinue={() => onDelete()}
    primaryActionButtonColor="red"
    // disabled={isLoading}
  />
);
